/**
 * @file voiceMailConstants.js
 * @description Constants for the Voicemail module within the Agent section.
 *              Includes error messages, UI label strings, and empty-state messages.
 *
 * @module voiceMailConstants
 *
 * @exports VOICEMAIL_ERRORS    - Error message strings for fetch, init & call control operations.
 * @exports VOICEMAIL_STRINGS   - UI label strings for the voicemail panel and actions.
 */
export const VOICEMAIL_ERRORS = {
    FETCH_PENDING_VOICEMAIL_ERROR: "Error fetching pending voicemail:",
    LOAD_VOICEMAILS_FAILED: "Failed to load pending voicemails. Please try again.",
    MISSING_ACS_TOKEN: "Missing ACSIdentityToken in localStorage.",
    INIT_AGENT_FAILED: "Failed to initialize call agent:",
    START_VOICEMAIL_ERROR: "Error starting voicemail:",
    HANGUP_ERROR: "Error hanging up:",
};

export const VOICEMAIL_STRINGS = {
    VOICEMAIL_PANEL: "Voicemail Panel",
    LISTEN: "Listen",
    STOP: "Stop",
    LOADING: "Loading...",
    NO_VOICEMAILS: "No pending voicemails found.",
};